import { render, staticRenderFns } from "./diveshop.vue?vue&type=template&id=7253767b&scoped=true&"
import script from "./diveshop.vue?vue&type=script&lang=js&"
export * from "./diveshop.vue?vue&type=script&lang=js&"
import style0 from "./diveshop.vue?vue&type=style&index=0&id=7253767b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253767b",
  null
  
)

export default component.exports